import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { GET_VL_CONNECT_ACTIVITY_REPORT } from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";

export const getDataListing = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const { data } = await axios.post(
      "api/VLConnectReports/GetVLConnectActivityReport",
      postedData
    );

    dispatch({
      type: GET_VL_CONNECT_ACTIVITY_REPORT,
      payload: data?.response || [],
    });

  } catch (error) {

    if (error.response) {

      const { status, data } = error.response;

      if (status === 401) {
        logout();
        history.push("/login");
        return;
      }

      if (status === 400 && data?.errors) {
        const errorMessage = Object.values(data.errors).join(", \n");
        toast.error(errorMessage);
        return;
      }

      toast.error(data?.Message || data?.message || "Error while processing the request");

    } else {
      toast.error("Error while processing the request");
    }

  } finally {
    dispatch(hideLoading());
  }
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.post(
      `api/VLConnectReports/GetVLConnectActivityReport`,
      { ...requestData, IsExport: true }
    );

    const outputFilename = `VL_Connect_Activities_Report_${Date.now()}`;
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const selectedColumns = [
      "distributor",
      "distCenter",
      "date",
      "day",
      "totalViz",
      "totalDistShop",
      "totalActivities",
      "totalOrder",
      "totalInfo",
      "totalComplaint",
      "totalOthers",
      "totalActivitiesClose",
      "totalUnresolvedActivities",
    ];

    const exportData = (dataArray) => {
      const formattedData = dataArray.map((row) => ({
        distributor: row.distributor ?? "",
        distCenter: row.distCenter ?? "",
        date: row.date ? new Date(row.date).toLocaleDateString() : "",
        day: row.day ?? "",
        totalViz: row.totalViz ?? 0,
        totalDistShop: row.totalDistShop ?? 0,
        totalActivities: row.totalActivities ?? 0,
        totalOrder: row.totalOrder ?? 0,
        totalInfo: row.totalInfo ?? 0,
        totalComplaint: row.totalComplaint ?? 0,
        totalOthers: row.totalOthers ?? 0,
        totalActivitiesClose: row.totalActivitiesClose ?? 0,
        totalUnresolvedActivities: row.totalUnresolvedActivities ?? 0,
      }));

      const ws = XLSX.utils.json_to_sheet(formattedData, {
        header: selectedColumns,
      });

      const wb = {
        Sheets: { Report: ws },
        SheetNames: ["Report"],
      };

      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const fileData = new Blob([excelBuffer], { type: fileType });

      fileSaver.saveAs(fileData, outputFilename + fileExtension);
    };

    exportData(data?.response?.data ?? []);
  } catch (error) {
    if (error.response) {
      if (error.response.status === 401) {
        logout();
        history.push("/login");
        return;
      }

      toast.error(
        error.response.data?.Message ||
          error.response.data?.message ||
          "Error while processing the request"
      );
    } else {
      toast.error("Error while processing the request");
    }
  } finally {
    dispatch(hideLoading());
  }
};
